import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { ModalHeader } from '@/design-system/components/modal';
import { TextBody } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { CancelCardStackParamList, CancelCardStackRoutes } from './type';
import { Dropdown } from '@/design-system/components/dropdown';
import { CardCancelReasonFilters } from '../../options';

export interface CancelCardProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  onData: (data: any) => void;
  account: string;
  tab?: number;
  record?: any;
  func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
  onReturnData?: (data: any) => void;
  refresh?: () => void;
}

export const CancelCardWebZeroScreen: React.FC<CancelCardProps> = (props) => {
  const { onClose, onLayout, onData, account, tab, record, func, onReturnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const { body, textMb, btnView, btn } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<CancelCardStackParamList>>();

  const [viewShow, setViewShow] = useState(false);
  const onChangeView = () => {
    setViewShow(!viewShow);
  };

  const [dt, setDt] = useState<any>({
    reason: 'lost',
    cardAccountId: account,
    cardId: record?.id
  });
  const [errorMsg, setErrorMsg] = useState<any>({
    reason: undefined
  });

  const changeCancelCard = () => {
    let validate = true;

    if (validate) {
      onData({ data: dt });
      navigation.navigate(CancelCardStackRoutes.Confirm, {
        onLayout,
        data: dt,
        account,
        tab,
        record,
        func,
        onReturnData,
        refresh,
        onChangeView
      });
    }
  };

  return (
    <View
      sx={{
        height: 'auto',
        width: layout.dimensions.width,
        maxWidth: Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <ModalHeader title={t('credit-card-cancel-card::glossary.cancel-card')} closeModal={onClose} />
      <View sx={body}>
        <TextBody sx={textMb} semiBold>
          {t('credit-card-cancel-card::cancel-card-form.text--please-select-reason')}
        </TextBody>
        <View sx={{ gap: '$5' }}>
          <View sx={{ zIndex: 99 }}>
            <Dropdown
              value={dt.reason}
              label={t('credit-card-cancel-card::glossary.reason')}
              options={CardCancelReasonFilters(t)}
              sx={{ width: '100%' }}
              dropdownSx={{ maxHeight: 100 }}
              onValueChange={(value) => {
                setDt({
                  ...dt,
                  reason: value
                });
              }}
            />
          </View>
        </View>
        {viewShow && <View sx={{ height: '$1', width: '100%' }} />}
        <View sx={btnView}>
          <UniButton
            sx={btn}
            variant={ButtonVariant.outline1}
            label={t('card-account-management::general.button--cancel')}
            onPress={onClose}
          />
          <UniButton
            sx={btn}
            labelSx={{ color: '$balck' }}
            label={t('credit-card-cancel-card::glossary.cancel-card')}
            onPress={changeCancelCard}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  textMb: {
    marginBottom: 20
  },
  btnView: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '$3',
    marginTop: 40,
    zIndex: -1
  },
  btn: {
    width: 216,
    height: 44
  }
};
